import { render, staticRenderFns } from "./auth-app.vue?vue&type=template&id=44d0a6a9"
import script from "./auth-app.vue?vue&type=script&lang=js"
export * from "./auth-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports